import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Close = (props: SVGIcon) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M14.476 0L16 1.524 9.523 8 16 14.476 14.476 16 8 9.523 1.524 16 0 14.476 6.477 8 0 1.524 1.524 0 8 6.477 14.476 0z"
    />
  </svg>
)
